import React from 'react';
import { MeResponse, CreateRequest, CreateResponse, ClientRegisterRequest, ClientRegisterResponse, UpdateRequest, UpdateResponse } from 'api/gen/account'

import { adlessCommand, adlessQuery, commandResponse } from '.';
import { TransactionsListResponse } from './gen/transactions';

export default {
    list: () => adlessQuery<TransactionsListResponse>("/v1/transactions/list"),
}